import { capitalize as capitalize$1 } from "../../string/capitalize.mjs";
import { toString } from "../util/toString.mjs";
//#region src/compat/string/capitalize.ts
/**
* Converts the first character of string to upper case and the remaining to lower case.
*
* @param {string} string - The string to capitalize.
* @returns {string} - The capitalized string.
*
* @example
* const convertedStr1 = capitalize('fred') // returns 'Fred'
* const convertedStr2 = capitalize('FRED') // returns 'Fred'
* const convertedStr3 = capitalize('') // returns ''
*/
function capitalize(str) {
	return capitalize$1(toString(str));
}
//#endregion
export { capitalize };
